import { LocaleAnchor } from '@/i18n/router';
import { useLocale, useMessages } from '@/i18n/LocaleProvider';
import { messages, type Messages } from '@/i18n/catalogs/editorial/articles-section';

import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';

const getItems = (m: Messages) => [
  {
    title: m.m000,
    excerpt: m.m001,
    author: 'Philip Moore',
    date: '2024-10-25',
    slug: 'powering-data-apis-with-arrow-flight-rpc-and-ibis',
    url: 'https://medium.com/@philipmoore_53699/powering-data-apis-with-arrow-flight-rpc-and-ibis-d8b25e06c942?source=rss-792205bfd4b6------2'
  },
  {
    title: m.m002,
    excerpt: m.m003,
    author: 'Philip Moore',
    date: '2022-06-08',
    slug: 'olap-hierarchical-aggregation-with-sql',
    url: 'https://medium.com/learning-sql/olap-hierarchical-aggregation-with-sql-6c45ebc206d7?source=rss-792205bfd4b6------2'
  }
];

const ArticlesSection = () => {
  const m = useMessages(messages);
  const articles = getItems(m);
  const { locale, formatLocale } = useLocale();
  return (
    <section id="articles" className="scroll-mt-24 section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <SectionHeading anchor="articles" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {m.m004}{' '}</SectionHeading>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {m.m005}{' '}</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <Card key={index} className="hover:shadow-lg dark:hover:shadow-white/20 transition-shadow border border-gray-200">
              <CardHeader className="bg-gray-50">
                <CardTitle className="text-xl font-bold text-gray-900 hover:text-gizmo-600 transition-colors">
                  {article.title}
                </CardTitle>
                <CardDescription>
                  <span className="text-gizmo-600">{new Date(article.date).toLocaleDateString(formatLocale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })}</span> <span className="mx-2">•</span> {m.m006}{' '}{article.author}
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-gray-700">{article.excerpt}</p>
              </CardContent>
              <CardFooter>
                <LocaleAnchor
                  href={article.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center text-gizmo-600 hover:text-gizmo-700"
                >
                  <Button variant="ghost" className="p-0 hover:bg-transparent">
                    {m.m007}{' '}<ExternalLink className="ml-1 h-4 w-4" />
                  </Button>
                </LocaleAnchor>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;
